<template>
  <h1 class='title'>
    <p>
      <img class="img1" src="~@/assets/imgs/icon/title.svg" alt="">
      <img class="img2" src="~@/assets/imgs/icon.png" alt="">
    </p>
    <a href="https://t.me/+yVgJ4mHwT-M1NjM1" target="_blank"><img class="img3" src="~@/assets/imgs/icon/tw.svg" alt=""></a>
  </h1>
</template>

<script>
  export default {
    name: "title",
  }
</script>

<style lang="scss" type="text/scss" scoped>
.title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .img2 {
    position: absolute;
    height: 24px;
    left: 135px;
    bottom: -6px;
  }
}
</style>